import { render } from "./DetailStoreHeader.vue?vue&type=template&id=7d835596&scoped=true"
import script from "./DetailStoreHeader.vue?vue&type=script&lang=js"
export * from "./DetailStoreHeader.vue?vue&type=script&lang=js"

import "./DetailStoreHeader.vue?vue&type=style&index=0&id=7d835596&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d835596"]])

export default __exports__